export default "__VITE_ASSET__bf39b504__"